import React, { useRef, useLayoutEffect } from 'react';
import styled from 'styled-components';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

import Img1 from '../assets/joker_tour_compressed.jpg';
import Img2 from '../assets/oddisey_compressed.jpg';
import Img3 from '../assets/joker_odissey_compressed.jpg';
import Img4 from '../assets/collobaration_compressed.jpg';

gsap.registerPlugin(ScrollTrigger);

const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  position: relative;
  text-align: center;
  background-color: black;
`;

const Title = styled.p`
  font-size: 8rem;
  font-family: 'MongoGrotesqueLight';
  margin: 0;
  color: #fff;
  display: flex;
  align-items: center;

  @media (max-width: 900px) {
    font-size: 5rem;
  }
  @media (max-width: 410px) {
    font-size: 4rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1rem;
  margin: 0;
  color: white;
`;

const TitreContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin-top: 2%;
  text-align: center;
  width: 80%;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4rem;
  width: 90%;
  margin-top: 3rem;

  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  opacity: 0;
`;

const CardImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  margin-bottom: 1rem;
`;

const CardTitle = styled.p`
  font-size: 2.2rem;
  font-family: 'MongoGrotesqueLight';
  color: #fff;
  margin: 0.5rem 0 0.25rem;
  text-align: left;
`;

const CardSubtitle = styled.p`
  font-size: 1rem;
  color: #ddd;
  margin: 0;
`;

const DiscoverButtonCard = styled.button`
  margin-top: 2%;
  background: #fff;
  border: 1px solid #333;
  border-radius: 20px;
  padding: 0.5rem 2rem;
  color: #000;
  font-size: 1rem;
  text-decoration:none;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
  &:hover {
    background: black;
    color: white;
    border-color: white;
    transition: background 0.5s ease;
  }
  @media (max-width: 900px) {
    font-size: 0.9rem;
    padding: 0.9rem ;
  }

`

const Exclusif: React.FC = () => {
  const items = [
    {
      img: Img1,
      title: 'JOKER TOUR - FRANCE 2023',
      subtitle:
        'Partouche Multiverse a parcouru ses casinos pour présenter le projet Joker Club, expliquer le Web3 avec pédagogie et échanger directement avec ses clients.',
    },
    {
      img: Img2,
      title: 'JOKER ODISSEY - CANNES 2024',
      subtitle:
        'Organisé par Partouche Multiverse à bord d’un yacht face au Palais, un rendez-vous exclusif entre Web3, art et innovation.',
    },
    {
      img: Img3,
      title: 'JOKER CLUB - PRESENT SUR LES GRANDS SALONS WEB3',
      subtitle:
        'Partouche Multiverse a parcouru ses casinos pour présenter le projet Joker Club, expliquer le Web3 avec pédagogie et échanger directement avec ses clients.',
    },
    {
      img: Img4,
      title: 'DES COLLABORATEURS D ENVERGURE',
      subtitle:
        'Organisé par Partouche Multiverse à bord d’un yacht face au Palais, un rendez-vous exclusif entre Web3, art et innovation..',
    },
  ];

  const cardRefs = useRef<Array<HTMLDivElement | null>>([]);

  useLayoutEffect(() => {
    cardRefs.current.forEach((el) => {
      if (!el) return;
      gsap.fromTo(
        el,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        }
      );
    });

    return () => {
      ScrollTrigger.getAll().forEach((t) => t.kill());
    };
  }, []);

  return (
    <PageContainer>
      <TitreContainer>
        <Title>DES ÉVÉNEMENTS EXCLUSIFS</Title>
        <Subtitle>
          Entre événements immersifs, rencontres pédagogiques, salons Web3
          <br />
          et collaborations internationales, le Joker Club construit un écosystème vivant,
          <br />
          ouvert et en constante évolution.
        </Subtitle>
      </TitreContainer>

      <Grid>
        {items.map((item, idx) => (
          <Card
            key={idx}
            ref={(el) => {
              cardRefs.current[idx] = el;
            }}
          >
            <CardImage src={item.img} alt={item.title} />
            <CardTitle>{item.title}</CardTitle>
            <CardSubtitle>{item.subtitle}</CardSubtitle>
          </Card>
        ))}
      </Grid>
      <DiscoverButtonCard onClick={() => window.open('https://lu.ma/user/usr-NS6HtFZzCVnD0Jl', '_blank')}>S’INSCRIRE AUX PROCHAINS ÉVÈNEMENTS</DiscoverButtonCard>
    </PageContainer>
  );
};

export default Exclusif;